import { AxiosResponse } from 'axios';
import api from '../../../services/api';
import { SearchEngineInterface } from '@e3labs/isa-data-dictionary';

class OrderSplitService {
  getAllOrderSplit() {
    return api.get('/order-split/');
  }
  getOrderSplit(id: any) {
    return api.get(`/order-split/${id}`);
  }
  deleteOrderSplit(id: any) {
    return api.delete(`/order-split/${id}`);
  }
  createOrderSplit(payload: any): Promise<AxiosResponse<any | null>> {
    return api.post('/order-split/', payload);
  }
  editOrderSplit(payload: any): Promise<AxiosResponse<any | null>> {
    return api.put('/order-split/', payload);
  }

  postProductsMinimized(
    {
      skip,
      limit,
      queryString,
      searchEngine,
      count,
      productExternalCodes
    }: {
      skip: number;
      limit: number;
      queryString?: string;
      searchEngine?: SearchEngineInterface;
      count?: boolean;
      productExternalCodes?: string;
    },
    opts?: any
  ) {
    return api.post<any[]>(
      `/product/minimized`,
      {
        searchEngine,
        count,
        productExternalCodes
      },
      {
        params: {
          skip: skip ?? undefined,
          limit: limit ?? undefined,
          queryString
        },
        ...opts
      }
    );
  }
}

export default new OrderSplitService();
